import React from 'react'
import useAppContext from '../../context/Context';
import { Column } from '../Column/Column'
import { Icon } from '../Icon/Icon'
import './Cms.scss'
const Cms = () => {
    const { activeCountry } = useAppContext();

    return (
        <Column customClass={activeCountry ==="cl"?"section4":"section4 section4AltBackground"}>
            <h4 className="top-title">
                Plugins CMS
            </h4>
            <h2 className="title">
                Perfecto para tu e-commerce
            </h2>
            <h3 className="description">
                Ponemos a tu disposición plugins para que puedas incorporar el botón de pago súper rápido.
            </h3>

            <div className="container-plugins m-button">
                <div className="icons-plugins">
                    <div className="plugin1">
                        <img src="/icons/Woocomerce.svg"></img>
                        <div className="info-plugin">
                            <p className="title-plugin">WooComerce</p>
                            <a target={'_blank'} className="link-documentation" href="https://etpay.notion.site/Woocommerce-8567386aa38c4849963f915bf766176d">Ir a la documentación <Icon name="Icon_After" color="white" /></a>
                        </div>
                    </div>
                </div>
                <div className="icons-plugins">
                    <div className="plugin1">
                        <img src="/icons/Magento.svg"></img>
                        <div className="info-plugin">
                            <p className="title-plugin">Magento</p>
                            <a target={'_blank'} className="link-documentation" href="https://etpay.notion.site/Magento-2-0175624abf17465bae40754363df5a01">Ir a la documentación <Icon name="Icon_After" color="white" /></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-plugins m-button m-left">
                <div className="icons-plugins">
                    <div className="plugin1">
                        <img src="/icons/Prestashop.svg"></img>
                        <div className="info-plugin">
                            <p className="title-plugin">Prestashop</p>
                            <a target={'_blank'} className="link-documentation" href="https://etpay.notion.site/Prestashop-02780e793cc94ad5be44206daa39e7cd">Ir a la documentación <Icon name="Icon_After" color="white" /></a>
                        </div>
                    </div>
                </div>
                <div className="icons-plugins">
                    <div className="plugin1">
                        <img src="/icons/VTEX.svg"></img>
                        <div className="info-plugin">
                            <p className="title-plugin">VTEX</p>
                            <p style={{margin: '0'}} className="link-documentation">Contacta con nuestro equipo</p>
                            <p style={{margin: '0', fontWeight:'400'}} className="link-documentation">soporte@etpay.com</p>
                            {/* <a className="link-documentation" href="/">Ir a la documentación <Icon name="Icon_After" color="white" /></a> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-plugins m-button">
                <div className="icons-plugins">
                    <div className="plugin1">
                        <img src="/icons/ETpay.svg"></img>
                        <div className="info-plugin">
                            <p className="title-plugin">API</p>
                            <a target={'_blank'} className="link-documentation" href={activeCountry==='cl' ? "https://etpay.notion.site/Quick-Transfer-ed001e382e904a9ba6551fe3c0831ed9" : 'https://etpay.notion.site/Quick-Transfer-c6cc0d6b954347dcaed6844c8b176cfe'}>Ir a la documentación <Icon name="Icon_After" color="white" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </Column>
    )
}

export default Cms